/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordVerifyAttestationData
 */
export interface PasswordVerifyAttestationData {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerifyAttestationData
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordVerifyAttestationData interface.
 */
export function instanceOfPasswordVerifyAttestationData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function PasswordVerifyAttestationDataFromJSON(json: any): PasswordVerifyAttestationData {
    return PasswordVerifyAttestationDataFromJSONTyped(json, false);
}

export function PasswordVerifyAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordVerifyAttestationDataToJSON(value?: PasswordVerifyAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

